<h3>
    <span class="title" ng-bind-html="item.displayName|cHighlight:highlight"></span>
</h3>
<div class="property-container">
    <ul class="workflow-property-list">
        <li>{{item.userTypeLabel|translate}}</li>
        <li ng-bind-html="item.userRoleName|cHighlight:highlight"></li>
        <li ng-bind-html="item.userName|cHighlight:highlight"></li>
        <li ng-if="item.jobTitle" ng-bind-html="item.jobTitle|cHighlight:highlight"></li>
        <li ng-if="item.firstWorkUnit" ng-bind-html="item.firstWorkUnit|cHighlight:highlight"></li>
        <li ng-if="item.metadata && item.metadata !== ''" ng-bind-html="item.metadata|cHighlight:highlight">{{item.metadata}}</li>
    </ul>
</div>
